export const SMARTCOMMERCE_BUTTON_ID = "83def80d-6c9c-4b2d-a080-1f5fc2cbe7d5";
export const SMARTCOMMERCE_CAROUSEL_ID = "78fea35b-65eb-4e11-82a4-4ccae5e69fd9";
export const SMARTCOMMERCE_LOCATOR_ID = "a6cb7c56-552c-4903-922c-3974653b7183";

export const SMARTCOMMERCE_CSS =
  "https://s3.us-west-2.amazonaws.com/static.smartcommerce.co/assets/client/Z4USXV/css/smartcart_poppi_us_prod.css";
export const SMARTCOMMERCE_CLIENT_JS =
  "https://s3.us-west-2.amazonaws.com/static.smartcommerce.co/assets/client/Z4USXV/js/smartcart_poppi_us_prod.js";
export const SMARTCOMMERCE_ENGINE_JS =
  "https://ss.click2cart.com/assets/js/smartcart_min.js";

export const DRINKS_COLLECTION_ID = "454317015330";
export const COMMERCE_CURRENCY = "USD" as const;

export interface CommerceProduct {
  handle: string;
  name: string;
  productId: string;
  variantId: string;
  price: number;
  sku?: string;
  upc: string;
  type: "single flavor" | "variety pack";
  variant: "12 Pack";
}

// Production catalog identifiers captured from drinkpoppi.com's collection
// payload and SmartCommerce data attributes on 2026-08-26. Keep this as the
// single source of truth for SmartButtons, analytics, and structured data.
export const COMMERCE_PRODUCTS: readonly CommerceProduct[] = [
  {
    handle: "sour-apple",
    name: "Sour Apple",
    productId: "10436594172194",
    variantId: "52225206583586",
    price: 23.97,
    upc: "10810063712805",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "shirley-temple",
    name: "Shirley Temple",
    productId: "9977156993314",
    variantId: "50717557883170",
    price: 19.95,
    upc: "810063712471",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "orange-cream",
    name: "Orange Cream",
    productId: "9089545011490",
    variantId: "48168841249058",
    price: 23.97,
    sku: "B0CZY4H7K5",
    upc: "810063710880",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "strawberry-lemon",
    name: "Strawberry Lemon",
    productId: "8446684660002",
    variantId: "45891719201058",
    price: 24.54,
    sku: "B084L3Z6LY",
    upc: "709586514856",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "wild-berry-12oz",
    name: "Wild Berry",
    productId: "9362901467426",
    variantId: "48812413878562",
    price: 35.99,
    upc: "810063711078",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "lemon-lime",
    name: "Lemon Lime",
    productId: "8992560873762",
    variantId: "47874677145890",
    price: 24.54,
    sku: "B0CQ8TQGR6",
    upc: "810063710316",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "cream-soda",
    name: "Cream Soda",
    productId: "9600224952610",
    variantId: "49514768728354",
    price: 29.88,
    upc: "810063711481",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "rootbeer",
    name: "Root Beer",
    productId: "9748806304034",
    variantId: "49991387676962",
    price: 19.95,
    sku: "B08T6LZWKW",
    upc: "810063710323",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "alpine-blast",
    name: "Alpine Blast",
    productId: "9669387944226",
    variantId: "49732080501026",
    price: 29.88,
    upc: "810063711702",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "doc-pop",
    name: "Doc Pop",
    productId: "8446683578658",
    variantId: "45891710386466",
    price: 23.97,
    upc: "810063710309",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "orange",
    name: "Orange",
    productId: "8446684365090",
    variantId: "45891716972834",
    price: 23.97,
    sku: "B084KSS69G",
    upc: "724190812877",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "cherry-cola",
    name: "Cherry Cola",
    productId: "9373672145186",
    variantId: "48838939148578",
    price: 29.88,
    upc: "810063711054",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "ginger-lime",
    name: "Ginger Lime",
    productId: "8446684234018",
    variantId: "45891716251938",
    price: 29.88,
    sku: "B084KXX75P",
    upc: "709586514870",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "raspberry-rose",
    name: "Raspberry Rose",
    productId: "8446684823842",
    variantId: "45891721003298",
    price: 23.97,
    sku: "B084KV65KJ",
    upc: "709586514894",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "grape",
    name: "Grape",
    productId: "8446683808034",
    variantId: "45891711992098",
    price: 23.97,
    sku: "B0BWSMRPHM",
    upc: "810063710392",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "cherry-limeade",
    name: "Cherry Limeade",
    productId: "8446684496162",
    variantId: "45891718086946",
    price: 23.97,
    sku: "B0B6GWKTZD",
    upc: "810063710071",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "watermelon",
    name: "Watermelon",
    productId: "8446684004642",
    variantId: "45891714154786",
    price: 29.88,
    sku: "B08DRB67KB",
    upc: "709586514832",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "classic-cola",
    name: "Classic Cola",
    productId: "8446683152674",
    variantId: "45891703963938",
    price: 29.49,
    sku: "B08T6NT456",
    upc: "810063710293",
    type: "single flavor",
    variant: "12 Pack",
  },
  {
    handle: "fall-for-flavor",
    name: "Fall for Flavor",
    productId: "10436595515682",
    variantId: "52225210089762",
    price: 0,
    upc: "810063713140",
    type: "variety pack",
    variant: "12 Pack",
  },
  {
    handle: "major-mix",
    name: "Major Mix",
    productId: "9993423913250",
    variantId: "50787705880866",
    price: 29.99,
    upc: "810063712587",
    type: "variety pack",
    variant: "12 Pack",
  },
  {
    handle: "crowd-pleasers",
    name: "Crowd Pleasers",
    productId: "9362919293218",
    variantId: "48812476760354",
    price: 29.99,
    sku: "B09B8CCPCZ",
    upc: "810063711238",
    type: "variety pack",
    variant: "12 Pack",
  },
  {
    handle: "functional-favorites",
    name: "Fun Favorites",
    productId: "8456808497442",
    variantId: "46450969870626",
    price: 28.98,
    sku: "B094LFK6DF",
    upc: "167386826",
    type: "variety pack",
    variant: "12 Pack",
  },
  {
    handle: "short-list",
    name: "Short List",
    productId: "8456817475874",
    variantId: "46450961973538",
    price: 29.99,
    sku: "B084RR2DQX",
    upc: "0686603351680",
    type: "variety pack",
    variant: "12 Pack",
  },
  {
    handle: "trend-setters",
    name: "Trend Setters",
    productId: "9224126988578",
    variantId: "48476349989154",
    price: 29.99,
    sku: "B0CZY3XG8H",
    upc: "810063711269",
    type: "variety pack",
    variant: "12 Pack",
  },
  {
    handle: "classics",
    name: "Classics",
    productId: "8456816525602",
    variantId: "46450965971234",
    price: 29.99,
    sku: "B09B8CCPCZ",
    upc: "167380667",
    type: "variety pack",
    variant: "12 Pack",
  },
] as const;

const COMMERCE_PRODUCTS_BY_HANDLE = new Map(
  COMMERCE_PRODUCTS.map((product) => [product.handle, product])
);

export function getCommerceProduct(
  handle: string
): CommerceProduct | undefined {
  return COMMERCE_PRODUCTS_BY_HANDLE.get(handle);
}

export function getProductUpc(handle: string): string | undefined {
  return getCommerceProduct(handle)?.upc;
}
